
import { Vue, Component, Prop } from 'vue-property-decorator';
import LIST_DIRECTORY from '@/apollo/directory/ListDirectorySimple.gql';
import LIST_DIRECTORY_INVITE from '@/apollo/directory/ListDirectoryInvite.gql';
import GET_REQUEST_CONTRACTOR_TOTAL from '@/apollo/jobboard/GetRequestContractorTotal.gql';
import Breadcrumbs from '@/components/breadcrumbs/BreadcrumbsNew.vue';
import TabsWithRoutes from '@/components/common/TabsWithRoutesNew.vue';
import LIST_COMPANY_REQUESTS from '@/apollo/jobboard/ListCompanyRequests.gql';
import commonContractorRequestConditions from '@/data/contractorReguests/commonContractorRequestConditions';
import TabNotificationBubble from '@/components/common/TabNotificationBubbleNew.vue';
import LIST_CONTRACTORS from '@/apollo/contractors/ListContractors.gql';
import InvitationSideBar from '@/components/companyContractors/invitationsidebarNew.vue';
import {
	Company,
	Manager_Contractor_Bool_Exp,
	Contractor_Bool_Exp,
	User,
	Custom_Request_Bool_Exp,
} from '@/generated/graphql';
import Roles from '@/entities/Roles';
import RouteTabs from '@/entities/RouteTabs';
import RouteNames from '@/entities/RouteNames';
import NavGrayArrow from '@/components/icons//NavGrayArrow.vue';
import { CustomRequestStatus } from '@/entities/CustomRequestStatus';
import { Contractor_status } from '@/data/contractorsStatus';

@Component({
	components: {
		TabsWithRoutes,
		TabNotificationBubble,
		NavGrayArrow,
		Breadcrumbs,
		InvitationSideBar,
	},
	apollo: {
		contractors: {
			query: LIST_DIRECTORY,
			variables() {
				return this.directoryFilter;
			},
			update(data) {
				this.contractorsNumber = data.total.aggregate.count;
				return data.contractor;
			},
		},
		favContractors: {
			query: LIST_DIRECTORY,
			variables() {
				return this.directoryFilterFav;
			},
			update(data) {
				const getFav = data.contractor.filter((item) =>  {
					if(item.user.favorited_by_users.length > 0){
					return item.user.favorited_by_users.id = this.currentUser.id
					}
				});
				this.favouriteTotal = getFav.length;
				return data.contractor;
			},
		},
		requestContractorNumber: {
			query: GET_REQUEST_CONTRACTOR_TOTAL,
			variables() {
				return this.conditions;
			},
			update(data) {
				this.customRequestsNumber = data.customRequests.aggregate.count;
			},
		},
		contractorArchiveNumber: {
			query: LIST_DIRECTORY,
			variables() {
				return this.directoryFilterArchive;
			},
			update(data) {

				this.customArchiveNumber = data.total.aggregate.count;
			},
		},
		archivedContractorsRequets: {
			query: LIST_CONTRACTORS,
			variables() {
				return this.archivedFilter;
			},
			update(data) {
				this.requestsNumber = data.total.aggregate.count;
				return data.contractor;
			},
		},
		notInviteRequets: {
			query: LIST_DIRECTORY,
			variables() {
				return this.pendingInviteFilter;
			},
			update(data) {
				this.customPendingNumber = data.total.aggregate.count;
				return data.contractor;
			},
		},
		requests: {
			query: LIST_COMPANY_REQUESTS,
			variables() {
				return this.requestsConditions;
			},
			update(data) {
				this.managerRequestTotal = data.total.aggregate.count;
				return data.requests;
			},
		},
	},
})
export default class AdminContractorsTabContainer extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;

	contractorsNumber: number = 0;
	requestsNumber: number = 0;
	customRequestsNumber: number = 0;
	managerRequestTotal: number = 0;
	customArchiveNumber: number = 0;
	customPendingNumber: number = 0;
	favouriteTotal: number = 0;
	routes = RouteNames;
	containerClasses: string = 'h-full';

	get isResourcesPage(): boolean {
		return this.$route.path.includes('/company_database/');
	}
	get isTalentMapping(): boolean {
		return this.$route.path.includes('/talent-mapping');
	}
	get isAdmin(): boolean {
		return this.currentUser.role === Roles.ADMIN;
	}

	get pendingInviteFilter() {
		const contractorsConditions = [
			{
				approved: {
					_eq: true,
				},
				deleted: {
					_eq: false,
				},
				_or: [
					{
						user: {
							pending_invite: {
								_eq: true,
							},
						},
					},
					{
						user: {
							pending_invite: {
								_eq: true,
							},
						},
					},
				],
			},
		];
		return {
			offset: 0,
			limit: null,
			where: {
				_and: contractorsConditions,
			},
			id: this.currentUser.id,
		};
	}

get directoryFilterFav() {
		const contractorsConditions: Contractor_Bool_Exp[] = [
      {
        approved: { _eq: true },
        deleted: { _eq: false },
        _or: [
          {
            user: {
              archived: {
                _is_null: true,
              },
            },
          },
          {
            user: {
              archived: {
                _eq: false,
              },
            },
          },
        ],
      },
    ];

		if (this.isManager) {
      const managerId = this.currentUser.manager!.id;

      contractorsConditions.push({
        managers: {
          _and: [
            { manager_id: { _eq: managerId } },
            { approved: { _eq: true } },
          ],
        },
         user: {
              contracts: {
                managers: {
                  approved: { _eq: true},
                },
              },
            },
      });
    }
		return {
			offset: 0,
			limit: null,
			where: {
				_and: contractorsConditions,
			},
			id: this.currentUser.id,
		};
	}
	get directoryFilter() {
		const contractorsConditions: Contractor_Bool_Exp[] = [
      {
        approved: { _eq: true },
        deleted: { _eq: false },
        _or: [
          {
            user: {
              archived: {
                _is_null: true,
              },
            },
          },
          {
            user: {
              archived: {
                _eq: false,
              },
            },
          },
        ],
      },
    ];

		return {
			offset: 0,
			limit: null,
			where: {
				_and: contractorsConditions,
			},
			id: this.currentUser.id,
		};
	}

	get getNumber() {
		if (this.isAdmin) {
			return this.requestsTotal;
		} else {
			return this.managerRequestTotal;
		}
	}

	get requestsConditions(): Object {
		return {
			where: {
				_and: [...commonContractorRequestConditions],
			},
		};
	}

	get directoryFilterArchive() {
		const contractorsConditions = [
			{
				approved: {
					_eq: true,
				},
				deleted: {
					_eq: false,
				},
				user: {
					archived: {
						_eq: true,
					},
				},
			},
		];
		return {
			offset: 0,
			limit: null,
			where: {
				_and: contractorsConditions,
			},
			id: this.currentUser.id,
		};
	}

	get conditions() {
		const requestsConditions: Manager_Contractor_Bool_Exp[] = [
			{
				approved: {
					_eq: false,
				},
			},
			{
				contractor: {
					deleted: {
						_eq: false,
					},
				},
			},
		];

		const contractorsConditions: Contractor_Bool_Exp[] = [
			{
				approved: {
					_eq: true,
				},
				deleted: {
					_eq: false,
				},
			},
		];

		const customRequestsWhere: Custom_Request_Bool_Exp = {
			status: {
				_in: [
					CustomRequestStatus.UNDER_REVIEW,
					CustomRequestStatus.APPLICANTS_SENT,
				],
			},
		};

		if (this.isManager) {
			requestsConditions.push({
				manager: {
					user: {
						id: {
							_eq: this.currentUser.id,
						},
					},
				},
			});
		}

		return {
			requestsWhere: {
				_and: requestsConditions,
			},
			contractorsWhere: {
				_and: contractorsConditions,
			},
			customRequestsWhere,
		};
	}

	get archivedFilter(): any {
		const conditions: Contractor_Bool_Exp[] = [
			{
				deleted: { _eq: true }
			},
		];
		return {
			offset: 0,
			limit: 10,
			where: {
				_and: conditions,
			},
			orderBy: [{ updated_at: 'desc' }],
		};
	}

	get isManager(): boolean {
		return this.currentUser.role === Roles.MANAGER;
	}

	get requestsTotal(): string {
		if (!this.requestsNumber && this.managerRequestTotal === 0) {
			return '';
		}
		const finalCount = this.requestsNumber + this.managerRequestTotal;
		return finalCount.toString();
	}

	get showRequestsBubble(): boolean {
		return this.requestsNumber > 0;
	}

	get showCondtractorsBubble(): boolean {
		return this.contractorsNumber > 0;
	}

	get showCustomRequestsBubble(): boolean {
		return this.customRequestsNumber > 0;
	}

	get customRequestsTotal(): string {
		if (!this.customRequestsNumber && this.customRequestsNumber !== 0) {
			return '';
		}

		return this.customRequestsNumber.toString();
	}
	get customArhiveTotal(): string {
		if (!this.customArchiveNumber && this.customArchiveNumber !== 0) {
			return '';
		}

		return this.customArchiveNumber.toString();
	}
	get contractorsTotal(): string {
		if (!this.contractorsNumber && this.contractorsNumber !== 0) {
			return '';
		}

		return this.contractorsNumber.toString();
	}

	get routeTabs(): RouteTabs {
		return {
			[RouteNames.COMPANY_DATABASE_CONTRACTORS]: `Resources`,
			[RouteNames.CONTRACTOR_FAV]: `Favourites`,
			[RouteNames.CONTRACTORS_REQUESTS]: `Requests`,
			[RouteNames.CUSTOM_REQUESTS]: `Talent Hunt`,
			[RouteNames.CONTRACTOR_PENDING]: `Invite not sent`,
			[RouteNames.CONTRACTOR_ARCHIVED]: `Archived`,

		};
	}

	refetchRequestsContractorsNumber(): void {
		this.$apollo.queries.requestContractorNumber.refetch();
	}
}
